import { render, staticRenderFns } from "./BookingApp.vue?vue&type=template&id=14b520d6"
import script from "./BookingApp.vue?vue&type=script&lang=js"
export * from "./BookingApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports